// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7e49e1bb","239":"58d199a9","453":"ad02e2af","732":"55168132"}[chunkId] + ".chunk.js";
};